import { Fragment, useState, useRef, useEffect, useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Pass from "bodycodi/cmap/app/components/common/pass";
import PassEmpty from "bodycodi/cmap/app/components/common/passEmpty";
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";
import icon_info from "bodycodi/cmap/app/svg/icon_info.svg";
import bpay_icon from "bodycodi/cmap/app/svg/bpay_icon.svg";

type AppointmentTabProp = {
  AppointPassList: Array<any>;
  active: any;
  setActive: Function;
  MemberDtlVO: any;
  openPassConfirmPop: () => void;
};

const AppointmentTab = ({
  AppointPassList,
  active,
  setActive,
  MemberDtlVO,
  openPassConfirmPop,
}: AppointmentTabProp) => {
  const [open, setOpen] = useState<boolean>(false);
  const [swiper, setSwiper] = useState<any>({});
  const dotWrap = useRef<HTMLDivElement>(null);
  const { dispatch } = useContext(DispatchContext);

  useEffect(() => {
    setActive(AppointPassList[0]);
  }, [AppointPassList]);

  const slideChange = () => {
    const index = swiper.activeIndex;
    const children = dotWrap.current?.querySelectorAll(".dot")!;
    for (let i = 0; i < children.length; i++) {
      children[i].classList.remove("active1");
    }
    children[index].classList.add("active1");
    setActive(AppointPassList[index]);
  };

  if (AppointPassList.length === 0) {
    return <PassEmpty />;
  }

  const classPassList = AppointPassList.map((d: any) => {
    return (
      <SwiperSlide key={d.seqPassInfo}>
        <Pass d={d} isAdd={false} open={open} setOpen={setOpen} />
      </SwiperSlide>
    );
  });

  const classDotList = AppointPassList.map((d: any, i: number) => {
    return <div className={"dot" + (i === 0 ? " active1" : "")} key={i}></div>;
  });

  const clickRsrv = () => {
    const data: any = {};
    if (active.appointmentMemberYn === "Y") {
      const center: any = {};
      center.seqPartner = active.seqPartner;
      center.seqPartnerBranch = active.seqPartnerBranch;
      center.partnerName = active.partnerName;
      center.companyName = active.companyName;
      center.seqPartnerCoach = active.seqPartnerCoach;
      data.addScheduleStep = 1;
      data.addScheduleType = "APPOINTMENT";
      data.addScheduleCenter = center;
      data.addScheduleSeqMember = MemberDtlVO;
      data.addSchedulePass = active;
      data.fromMngt = true;
      dispatch({ type: "UPDATE_ADDSCHEDULE", data: data });
    }
  };

  return (
    <Fragment>
      <Swiper
        onSwiper={(swiper) => {
          setSwiper(swiper);
        }}
        onSlideChange={slideChange}
      >
        {classPassList}
      </Swiper>
      <div className="member-pass-list-dot-wrap" ref={dotWrap}>
        {AppointPassList.length > 1 && <div className="dot-wrap">{classDotList}</div>}
      </div>
      {active?.appointmentMemberYn === "Y" ? (
        <div className="member-btn-container">
          <button
            className="member-btn-outlined"
            onClick={clickRsrv}
            disabled={
              (active.remainNumber === active.reservationScheduleCnt &&
                active.serviceKind === "N") || // 이용권의 잔여 횟수가 부족합니다
              active.status === "EXPIRATION" // 만료된 이용권 입니다
            }
          >
            스케줄 예약
          </button>
          <button className="member-btn active" onClick={openPassConfirmPop}>
            <img src={bpay_icon} />
            앱결제 요청
          </button>
        </div>
      ) : (
        <div className="pass-group-info">
          <img src={icon_info} />
          <span>개인레슨은 담당강사일 경우에만 스케줄 예약과 이용권 재결제 요청할 수 있어요.</span>
        </div>
      )}
    </Fragment>
  );
};

export default AppointmentTab;
